<script>
    export let horizontal = false;    
    
    export let w = 400;
    export let h = 600;

    export let stripesCount = 13;

</script>



<svg viewbox="0 0 {w} {h}" >

    {#if horizontal}
    {#each Array(stripesCount) as _, i}
        <rect width="{w}" height="{h/stripesCount}" x="0" y="{i * (h/stripesCount)}" fill="{i % 2 ? '#fff': '#000'}" />
    {/each}

    {:else}
        {#each Array(stripesCount) as _, i}
            <rect width="{w/stripesCount}" height="{h}" y="0" x="{i * (w/stripesCount)}" fill="{i % 2 ? '#fff': '#000'}" />
        {/each}
    {/if}

</svg>